import { render, staticRenderFns } from "./MyRejectedSessions.vue?vue&type=template&id=2b62e5c0"
import script from "./MyRejectedSessions.vue?vue&type=script&lang=js"
export * from "./MyRejectedSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports